/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const BuySellTrade = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 47 42" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M37.304 11.811c.574.495.863 1.204.863 2.111 0 1.157-.534 2.019-1.583 2.564-.305.161-.75.288-1.36.387v1.057h-1.438v-1.003c-.641-.053-1.178-.165-1.595-.333-.456-.183-.941-.511-1.442-.975l-.129-.12 1.216-1.216.119.11c.319.294.614.503.878.622.284.127.645.212 1.076.255v-2.676l-.203-.024c-.831-.093-1.493-.388-1.967-.877-.477-.491-.719-1.129-.719-1.894 0-.791.243-1.459.722-1.985.296-.316.617-.547.956-.688.294-.121.661-.22 1.088-.292V6.06h1.438v.751c.548.058.989.155 1.312.289.358.148.761.416 1.232.821l.141.12-1.177 1.158-.118-.097a3.317 3.317 0 0 0-.708-.464 2.997 2.997 0 0 0-.79-.207v2.591l.315.046c.795.122 1.426.372 1.873.743zm-3.395-3.359c-.758.149-1.126.565-1.126 1.266 0 .342.098.598.298.784.178.165.457.288.828.368zm2.118 6.407c.235-.184.349-.478.349-.897 0-.425-.113-.713-.342-.879-.219-.157-.527-.273-.918-.346v2.5c.389-.081.695-.208.911-.378z" /><path d="M24.39 12c0-5.514 4.486-10 10-10s10 4.486 10 10c0 4.783-3.377 8.787-7.87 9.766l1.624 1.624c4.782-1.58 8.246-6.085 8.246-11.39 0-6.617-5.383-12-12-12s-12 5.383-12 12c0 1.596.319 3.117.888 4.512h2.2A9.917 9.917 0 0 1 24.39 12" /><path d="M45.852 29.791c.075.143.114.303.114.465v5a1 1 0 0 1-1 1h-5.935a5.007 5.007 0 0 1-4.898 4c-2.757 0-5-2.243-5-5s2.243-5 5-5a5.007 5.007 0 0 1 4.898 4h4.935v-3.72c-.468-.697-2.407-3.087-7-3.087a1 1 0 0 1-.707-.293l-6.646-6.646h-8.608v2.491L14.96 19.51l6.045-3.49v2.49h9.023c.265 0 .519.106.707.293l6.651 6.652c6.207.173 8.374 4.162 8.466 4.336m-11.719 8.465c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3" /><g><path d="M20.938 38.75v-2.491h-4.074a5.009 5.009 0 0 1-4.899 4 5.009 5.009 0 0 1-4.899-4H1a1 1 0 0 1-1-1v-5.597c0-1.252.382-2.265 1.135-3.01 1.166-1.155 2.796-1.166 2.923-1.169h3.594l5.686-4.433 1.778 1.15-6.505 5.071a1.004 1.004 0 0 1-.616.212H4.048C3.567 27.486 2 27.654 2 29.662v4.597h5.066a5.009 5.009 0 0 1 4.899-4 5.009 5.009 0 0 1 4.899 4h4.074v-2.49l6.045 3.49zm-8.973-.491c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3z" /></g>
      </g>
    </svg>
  </span>
);

BuySellTrade.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

BuySellTrade.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default BuySellTrade;
